module.exports = __webpack_public_path__ + "static/scale-model-of-lupa-zoo-in-springfield-massachusetts-7114177c0f61ed787dc9d36b4a9cc748.png";